const selectAddress = $("#js-details-form-street");
const addressFields = $("#addressfields");

if (selectAddress.length) {
	addressFields.hide();

	selectAddress.on("change", function() {
		addressFields.hide('fast');

		if ($(this).val() != "") {
			if ($(this).val() == "manual") {
				addressFields.show('fast', function() {
					$("#input_addressLine1").focus();
				});
			} else {
				var address = $(this).val().split('|');
				for (var i=1;i<=3;i++) {
					if (address[i] != '') {
						$("#input_addressLine" + i).val(address[i]).closest(".form-group").removeClass("has-error");
					}
				}
			}
		}
	});
}